import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const PhaseContext = createContext({ phase: 1, launchDate: "2026-11-26" });

export const PhaseProvider = ({ children }) => {
  const [state, setState] = useState({ phase: 1, launchDate: "2026-11-26" });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/site/config`)
      .then(({ data }) => setState({ phase: data.phase, launchDate: data.launch_date }))
      .catch(() => {});
  }, []);

  return <PhaseContext.Provider value={state}>{children}</PhaseContext.Provider>;
};

export const usePhase = () => useContext(PhaseContext);
